export function getFormattedDate(date) {
  return date.toLocaleDateString("es-ES");
}

export function isContinuityCompleted(date, days) {
  const completed = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() + days
  );

  return new Date(Date.now()) >= completed;
}

export function isFutureDate(dateString) {
  const inputDate = new Date(dateString);
  const today = new Date(new Date().toISOString().split("T")[0]);
  return inputDate >= today;
}
